/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../client.ts';
import type {
  TelegramProductsUserControllerPatchMutationRequest,
  TelegramProductsUserControllerPatchMutationResponse,
  TelegramProductsUserControllerPatchPathParams,
  TelegramProductsUserControllerPatch401,
  TelegramProductsUserControllerPatch402,
} from '../types/TelegramProductsUserControllerPatch.ts';

function getTelegramProductsUserPatchUrl(link: TelegramProductsUserControllerPatchPathParams['link']) {
  const res = { method: 'PATCH', url: `/api/user/telegram/products/${link}` as const };
  return res;
}

/**
 * {@link /api/user/telegram/products/:link}
 */
export async function telegramProductsUserPatch(
  link: TelegramProductsUserControllerPatchPathParams['link'],
  data?: TelegramProductsUserControllerPatchMutationRequest,
  config: Partial<RequestConfig<TelegramProductsUserControllerPatchMutationRequest>> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    TelegramProductsUserControllerPatchMutationResponse,
    ResponseErrorConfig<TelegramProductsUserControllerPatch401 | TelegramProductsUserControllerPatch402>,
    TelegramProductsUserControllerPatchMutationRequest
  >({
    method: 'PATCH',
    url: getTelegramProductsUserPatchUrl(link).url.toString(),
    data: requestData,
    ...requestConfig,
  });
  return res.data;
}
